<modal-layout [modalTitle]="'Filters' | translate">

    <!-- content -->
    <div modalBody>
        <product-listing-tools [listing]="listing"></product-listing-tools>
    </div>

    <!-- footer -->
    <div class="p-t-1 p-b-1"
         modalFooter>
        <!-- close -->
        <button [buttonStyle]="'button'"
                class="m-b-0 w-12"
                (click)="close()">
            {{ 'SHOW RESULTS' | translate }}
        </button>
    </div>
</modal-layout>